import React from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

const chooseColor = (years, year, firstColor, secondColor, thirdColor, i) => {
  if (years[0] === year) return firstColor[i];
  if (years[1] === year) return secondColor[i];
  return thirdColor[i];
};

function UTTooltip(tooltipProps) {
  const { payload, label, firstColor, secondColor, thirdColor, unit, years } = tooltipProps;
  const translate = {
    transform: `translate(${tooltipProps.coordinate.x - 90}px, ${tooltipProps.coordinate.y - 90}px)`
  };
  return (
    <div style={[styles.container, translate]}>
      <UTLabel white extrabold>
        {payload.length > 0 && `Periodo ${payload[0].payload.period.substring(0, 4)} - ${label.slice(-2)}`}
      </UTLabel>
      <ul style={styles.ul}>
        {payload.map((item, i = Math.random()) => (
          <li key={i} style={styles.li}>
            <div
              style={{
                backgroundColor: chooseColor(
                  years,
                  payload[0].payload.year,
                  firstColor,
                  secondColor,
                  thirdColor,
                  i
                ),
                height: '12px',
                width: '12px',
                borderRadius: '10px',
                marginRight: '5px'
              }}
            />
            <UTLabel white small>
              {`${item.name}: ${item.payload[item.dataKey]} ${unit}`}
            </UTLabel>
          </li>
        ))}
      </ul>
      <div style={styles.arrow} />
    </div>
  );
}

export default Radium(UTTooltip);
